import { createFileRoute } from '@tanstack/react-router';
import { EditTemplateScreen } from '@/features/preparer/signature-templates/EditTemplateScreen';

export const Route = createFileRoute('/preparer/signature-templates/edit/$templateId')({
  component: EditTemplateScreen,
});
